import React, { useState, useEffect } from 'react';
import { getGateBypass, setGateBypass } from '../../services/auth';

interface GateBypassToggleProps {
  studentId: string;
  childName: string;
}

export const GateBypassToggle: React.FC<GateBypassToggleProps> = ({
  studentId,
  childName,
}) => {
  const [unlocked, setUnlocked] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    getGateBypass(studentId)
      .then((data) => setUnlocked(data.gates_unlocked))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [studentId]);

  const handleToggle = async () => {
    const newValue = !unlocked;
    setSaving(true);
    try {
      await setGateBypass(studentId, newValue);
      setUnlocked(newValue);
    } catch (err) {
      console.error('Failed to update gate bypass:', err);
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <p>Loading gate settings...</p>;

  return (
    <div className="gate-bypass-setting">
      <div className="setting-row">
        <div className="setting-info">
          <span className="setting-label">Unlock all units for {childName}</span>
          <span className="setting-description">
            Bypass mastery gates so {childName} can access all units without passing gate assessments.
            Useful for previewing content.
          </span>
        </div>
        <label className="toggle-switch">
          <input
            type="checkbox"
            checked={unlocked}
            onChange={handleToggle}
            disabled={saving}
          />
          <span className="toggle-slider" />
        </label>
      </div>
      {unlocked && (
        <p className="setting-warning">
          All units are currently unlocked. Gate assessments are still available but not required.
        </p>
      )}
    </div>
  );
};
